export const tableDataOptions = {
  data () {
    return {
      base_table_options: [
        {'id': 'Scoring', 'text': 'Scoring'},
        {'id': 'Assists', 'text': 'Assists'},
        {'id': 'Rebounds', 'text': 'Rebounds'},
        {'id': 'Turnovers', 'text': 'Turnovers'},
        {'id': 'Fouls', 'text': 'Fouls'},
        {'id': 'FTs', 'text': 'Free Throw Source'},
        {'id': 'Shooting', 'text': 'Shot Distribution'},
        {'id': 'SecondChance', 'text': 'Second Chance Stats'},
        {'id': 'Penalty', 'text': 'Penalty Stats'},
        {'id': 'Misc', 'text': 'Misc'}
      ],
      table_options_with_number_of_fouls: [
        {'id': 'Scoring', 'text': 'Scoring'},
        {'id': 'Assists', 'text': 'Assists'},
        {'id': 'Rebounds', 'text': 'Rebounds'},
        {'id': 'Turnovers', 'text': 'Turnovers'},
        {'id': 'Fouls', 'text': 'Fouls'},
        {'id': 'FTs', 'text': 'Free Throw Source'},
        {'id': 'Shooting', 'text': 'Shot Distribution'},
        {'id': 'SecondChance', 'text': 'Second Chance Stats'},
        {'id': 'Penalty', 'text': 'Penalty Stats'},
        {'id': 'Misc', 'text': 'Misc'},
        {'id': 'PlayingTimeByNumberOfFouls', 'text': 'Number of Fouls'}
      ],
      table_options_with_on_off_and_number_of_fouls: [
        {'id': 'Scoring', 'text': 'Scoring'},
        {'id': 'Assists', 'text': 'Assists'},
        {'id': 'Rebounds', 'text': 'Rebounds'},
        {'id': 'Turnovers', 'text': 'Turnovers'},
        {'id': 'Fouls', 'text': 'Fouls'},
        {'id': 'FTs', 'text': 'Free Throw Source'},
        {'id': 'Shooting', 'text': 'Shot Distribution'},
        {'id': 'SecondChance', 'text': 'Second Chance Stats'},
        {'id': 'Penalty', 'text': 'Penalty Stats'},
        {'id': 'Misc', 'text': 'Misc'},
        {'id': 'On-Off', 'text': 'On-Off'},
        {'id': 'PlayingTimeByNumberOfFouls', 'text': 'Number of Fouls'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/table_data_options.js